const PATHS = {
  HOME: '/',
  CARE_PLANET: '/cuidemoselplaneta',
}

export { PATHS }
